import {container, title} from "assets/jss/material-kit-react.jsx";

import imagesStyles from "assets/jss/material-kit-react/imagesStyles.jsx";

const projectPageStyle = {
    container,
    root: {
        background: "#fff",
        minHeight: "100vh"
    },
    raised: {
        zIndex: 10,
    },
    profile: {
        textAlign: "center",
        "& img": {
            maxWidth: "160px",
            width: "100%",
            margin: "0 auto",
            transform: "translate3d(0, -50%, 0)"
        }
    },
    main: {
        background: "#FFFFFF",
        position: "relative",
        zIndex: "3"
    },
    mainRaised: {
        zIndex: "3",
        borderRadius: "2px",
        boxShadow:
            "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },
    title: {
        ...title,
        position: "relative",
        marginTop: "30px",
        minHeight: "32px",
        color: "#FFFFFF",
        textDecoration: "none",
        textAlign: "center",
    },
    tag: {
        width: "auto",
        padding: "16px 8px"
    },
    imgFluid: {
        minHeight: "260px",
        maxWidth: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    imgRaised: {
        ...imagesStyles.imgRaised
    },
    imgRounded: {
        ...imagesStyles.imgRounded
    },
};

export default projectPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/projectPage.jsx